export default __webpack_public_path__ + "static/media/data.c4f47691.md";